module.exports = __webpack_public_path__ + "static/media/forward-bend.0d8406f5.webp";